module.exports = __webpack_public_path__ + "img/search-big-purple.b23d8ccf.png";